var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-center"},[_vm._v("\n\tMerci, vous avez complété le questionnaire Otelico\n")])}
var staticRenderFns = []

export { render, staticRenderFns }